import { EditFlightResponseMapped } from '../flight/_interfaces_/booked-flight.mapped.interface';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionStorageEnum } from '@enums/session-storage.enum';
export interface SessionStorageDataModel {
  searchData: EditFlightResponseMapped;
  wasFlightChangeConfirmed: boolean;
  selectedOrderData: string;
  commonOrderData: string;
}
export class SessionStorageModel {
  public SESSION_STORAGE = {} as SessionStorageDataModel;
}
@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private prefix: string = 'OM_';
  public storage: SessionStorageModel = new SessionStorageModel();

  private sessionDataSubject = new Subject<SessionStorageDataModel>();
  public sessionData$ = this.sessionDataSubject.asObservable();

  constructor() {
    Object.entries(this.storage).forEach(([key]) => {
      Object.defineProperty(this.storage, key, {
        get: () => this.getFromSession(key),
        set: (data: SessionStorageDataModel) => this.setForSession(key, data),
      });
    });
  }

  public getFromSession(key: string): SessionStorageDataModel {
    return sessionStorage.getItem(this.prefix + key) ? JSON.parse(sessionStorage.getItem(this.prefix + key)) : null;
  }

  public setForSession(key: string, value: SessionStorageDataModel): void {
    sessionStorage.setItem(this.prefix + key, JSON.stringify(value));

    if (key === SessionStorageEnum.SessionStorage) {
      this.sessionDataSubject.next(value);
    }
  }

  public updateFlightLegDate(legNumber: number, newDate: string): void {
    const sessionData = this.getFromSession(SessionStorageEnum.SessionStorage);

    if (sessionData?.searchData?.flightLeg) {
      const legIndex = sessionData.searchData.flightLeg.findIndex((leg) => leg.legNumber === legNumber);

      if (legIndex >= 0) {
        sessionData.searchData.flightLeg[legIndex].departureDate = newDate;
        this.setForSession(SessionStorageEnum.SessionStorage, sessionData);
      }
    }
  }

  public updateFlightLeg(legNumber: number, updates: Partial<any>): void {
    const sessionData = this.getFromSession(SessionStorageEnum.SessionStorage);

    if (sessionData?.searchData?.flightLeg) {
      const legIndex = sessionData.searchData.flightLeg.findIndex((leg) => leg.legNumber === legNumber);

      if (legIndex >= 0) {
        Object.keys(updates).forEach((key) => {
          sessionData.searchData.flightLeg[legIndex][key] = updates[key];
        });

        this.setForSession(SessionStorageEnum.SessionStorage, sessionData);
      }
    }
  }

  public getFlightLeg(legNumber: number) {
    const sessionData = this.getFromSession(SessionStorageEnum.SessionStorage);

    if (sessionData?.searchData?.flightLeg) {
      return sessionData.searchData.flightLeg.find((leg) => leg.legNumber === legNumber) || null;
    }

    return null;
  }

  public getAllFlightLegs() {
    const sessionData = this.getFromSession(SessionStorageEnum.SessionStorage);
    return sessionData?.searchData?.flightLeg || [];
  }

  public setUserEditingFlights(isEditing: boolean): void {
    if (isEditing) {
      sessionStorage.setItem(this.prefix + SessionStorageEnum.UserEditingFlight, 'true');
    } else {
      sessionStorage.removeItem(this.prefix + SessionStorageEnum.UserEditingFlight);
    }
  }

  public isUserEditingFlights(): boolean {
    const isEditing = sessionStorage.getItem(this.prefix + SessionStorageEnum.UserEditingFlight) === 'true';
    return isEditing;
  }

  public clearUserEditingFlag(): void {
    sessionStorage.removeItem(this.prefix + SessionStorageEnum.UserEditingFlight);
  }
}
